// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarCatalogoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/catalogo/migrar-todas
 * (controllers/migration/catalogo.php::migrar_todas).
 *
 * O fechamento da carga de catalogo de UMA franquia: o run do lote, a
 * contabilidade dos quatro desfechos (MigrationTally — `bloqueadas` NAO entra
 * em `falhas`, a distincao ja custou uma correcao na E1), o que o proprio
 * Zoho nao conseguiu exportar, e o desfecho de cada registro.
 *
 * `migradas + skipped + bloqueadas + falhas == total`, sempre.
 */
import type { Migration_CatalogoResultadoRow } from './Migration_CatalogoResultadoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_MigrarCatalogoResponseDados {
run_id: number
total: number
migradas: number
skipped: number
bloqueadas: number
falhas: number
erros_zoho: string[]
resultados: Migration_CatalogoResultadoRow[]
}

export type Migration_MigrarCatalogoResponse = ApiResponse<Migration_MigrarCatalogoResponseDados>;

registerResponseContract('Migration_MigrarCatalogoResponse', {
  run_id:     { type: 'number',  required: true },
  total:      { type: 'number',  required: true },
  migradas:   { type: 'number',  required: true },
  skipped:    { type: 'number',  required: true },
  bloqueadas: { type: 'number',  required: true },
  falhas:     { type: 'number',  required: true },
  erros_zoho: { type: 'array',   required: true },
  resultados: {
    type: 'array',
    required: true,
    items: {
      zoho_id:        { type: 'string',  required: false },
      nome:           { type: 'string',  required: false },
      tipo:           { type: 'string',  required: false },
      status:         { type: 'string',  required: false },
      run_id:         { type: 'number',  required: false },
      linha_local_id: { type: 'number',  required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
      erro:           { type: 'string',  required: false },
    },
  },
})
